import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HelocApplicationRequest, HelocApplicationResponse, HelocApplicationsPage } from '../models/heloc.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelocService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/HelocApplications`;

  submitApplication(data: HelocApplicationRequest): Observable<HelocApplicationResponse> {
    console.log('Sending HELOC application:', data);
    return this.http.post<HelocApplicationResponse>(this.apiUrl, data);
  }

  getApplications(pageNumber: number = 1, pageSize: number = 10): Observable<HelocApplicationsPage> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<HelocApplicationsPage>(this.apiUrl, { params });
  }

  getApplicationById(id: number): Observable<HelocApplicationResponse> {
    return this.http.get<HelocApplicationResponse>(`${this.apiUrl}/${id}`);
  }
}
